<template>
  <div>
    <dashboard-loader v-if="loader" />
    <section
      v-else
      class="mb-5"
    >
      <b-row class="match-height">
        <b-col
          xl="8"
          md="8"
          sm="12"
        >
            <b-card
                no-body
                class="card-statistics"
            >
                <b-card-header>
                  <div class="w-100 d-flex justify-content-between">
                      <div class="w-50">
                          <v-select
                              v-model="service"
                              :options="services"
                              :clearable="false"
                              @input="setServiceStatistics"
                              label="name"
                          />
                      </div>
                      <div class="w-50 d-flex justify-content-end">
                          <b-card-text class="font-small-2 mr-25 mb-0">
                              <b-button
                                  v-if="service.is_extendable"
                                  variant="primary"
                                  size="sm"
                                  @click="$router.push({name:'invoices-create',params:{
                                id: serviceId
                            }})"
                              >
                                  {{ $t('Extend panel') }}
                              </b-button>
                              <b-button
                                  v-if="!service.is_welcome"
                                  variant="danger"
                                  size="sm"
                                  @click="createInvoice(service,'message_packet')"
                              >
                                  {{ $t('Buy message') }}
                              </b-button>
                          </b-card-text>
                      </div>
                  </div>
                </b-card-header>
          <ecommerce-statistics
            :service="service"
            :data="statistics"
          />
            </b-card>
        </b-col>
        <b-col
          xl="4"
          md="4"
          class="d-none d-md-flex"
        >
          <messages-statistics
            icon="MailIcon"
            color="primary"
            :statistic="remainingMessages"
            :statistic-title="$t('Daily sent messages')"
            :statistic-sub-title="$t('Remaining message')"
            :chart-data="messageStatistics.series"
          />
        </b-col>
      </b-row>
      <b-row
        id="auto-chat-accounts"
        class="match-height"
      >
        <b-col md="12">
          <b-alert
            show
            variant="info"
          >
            <div class="alert-body">
              <feather-icon
                class="mr-25"
                icon="StarIcon"
              />
              <span class="ml-25">{{ $t('Whatsapp api accounts') }}: {{ $t('By clicking on the each account you can scan connect you whatsapp to api account by scan QR Code in you whats app or see connection details') }} </span>
            </div>
          </b-alert>
        </b-col>
        <!-- accounts cards sections -->
        <b-col
          v-for="account in accounts"
          :key="account.id"
          xl="3"
          lg="4"
          md="6"
        >
          <account-card
            :account="account"
            @onDeleteButtonClicked="deleteAccount"
          />
        </b-col>
        <b-col
          v-if="service.is_extendable || isAllowedAccount"
          xl="3"
          lg="4"
          md="6"
        >
          <b-card
            id="add-auto-chat-account"
            body-class="d-flex justify-content-center align-items-center"
          >
            <b-button
              variant="transparent"
              class="d-flex flex-column align-items-center"
              @click="createInvoice(service,'extra_account')"
            >
              <b-img
                v-if="isAllowedAccount"
                :src="require('@/assets/images/logo/whatsapp.png')"
                width="50"
              />
              <b-avatar
                v-else
                size="50"
                variant="light-success"
              >
                <feather-icon icon="ShoppingCartIcon" />
              </b-avatar>
              <strong class="mt-2">
                <span v-if="isAllowedAccount">{{ $t("Add new account") }}</span>
                <span v-else-if="service.can_buy_extra_account">{{ $t("Buy new account") }}</span>
                <span v-else-if="!service.is_expired">{{ $t("Upgrade panel") }}</span>
                <span v-else-if="service.is_extendable">{{ $t("Extend panel") }}</span>
              </strong>
            </b-button>
          </b-card>
        </b-col>
      <!--/ accounts cards sections -->
      </b-row>
    </section>
    <app-tour :steps="steps" />
    <create-account-modal v-if="service.accountTypes.length" :form="{
        name: '',
        type: service.accountTypes[0].key,
        service_id: serviceId,
      }" :services="services" />
    <create-invoice-modal
      :invoice-type="invoiceType"
      :service-id="serviceId"
    />
  </div>
</template>

<script>
import {
    BCard, BImg, BCol, BRow, BAlert, BButton, BAvatar, BCardTitle, BCardHeader, BCardText,
} from 'bootstrap-vue'
import AppTour from '@core/components/app-tour/AppTour.vue'
import AccountCard from '../../components/accounts/AccountCard'
import DashboardLoader from '../../components/loaders/DashboardLoader'
import EcommerceStatistics from '../../components/dashboard/EcommerceStatistics.vue'
import CreateAccountModal from '../../components/accounts/modals/CreateAccountModal'
import { numberFormat } from '../../common/utils/utils'
import MessagesStatistics from '../../components/dashboard/MessagesStatistics'
import CreateInvoiceModal from '../../components/invoices/modals/CreateInvoiceModal'
import vSelect from 'vue-select'

export default {
  components: {
      BCardText,
      vSelect,
      BCardHeader,
      BCardTitle,
    CreateInvoiceModal,
    MessagesStatistics,
    CreateAccountModal,
    DashboardLoader,
    AccountCard,
    BCard,
    BImg,
    BCol,
    BRow,
    EcommerceStatistics,
    AppTour,
    BAlert,
    BAvatar,
    BButton,
  },
  data() {
    return {
      loader: true,
      accounts: [],
      deleteSucceeded: false,
      services: [],
      service: {
        accountTypes : []
      },
      isAllowedAccount: false,
      remainingMessages: 0,
      invoiceType: '',
      serviceId: '',
      statistics: [
        {
          icon: 'MonitorIcon',
          color: 'light-info',
          title: 0,
          subtitle: this.$t('Total Accounts'),
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'MessageCircleIcon',
          color: 'light-secondary',
          title: 0,
          subtitle: this.$t('Total Messages'),
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'MessageSquareIcon',
          color: 'light-warning',
          title: 0,
          subtitle: this.$t('Today Messages'),
          customClass: 'mb-2 mb-sm-0',
        },
        {
          icon: 'CalendarIcon',
          color: 'light-success',
          title: '',
          subtitle: this.$t('Expire date'),
          customClass: 'mb-2 mb-sm-0',
        },
      ],
      messageStatistics: {
        series: [
          {
            name: this.$t('Message'),
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
    }
  },
  computed: {
    steps() {
      if (this.accounts.length > 1) {
        return [
          {
            target: '#auto-chat-accounts', // We're using document.querySelector() under the hood
            header: {
              title: 'اکانت های api  واتساپ',
            },
            content: 'هر اکانت api به یک اکانت واتساپ متصل می شود با کلیک بر روی هر اکانت میتوانید وضعیت اتصال آن را چک کنید',
          },
        ]
      } if (this.accounts.length === 1) {
        let content = `با کلیک بر روی اکانت ${this.accounts[0].name} شما می توانید وضعیت اتصال اکانت را بررسی کنید و با اسکن QR Code به واتساپ وصل شود`
        if (this.accounts[0].name === 'رایگان') content += '<br /> شما می تواند اکانت رایگان خود را به اکانت ها بالاتر ارتقاء دهید'
        return [
          {
            target: `#auto-chat-account-${this.accounts[0].id}`, // We're using document.querySelector() under the hood
            header: {
              title: 'اکانت های api  واتساپ',
            },
            content,
          },
        ]
      }
      return [{
        target: '#auto-chat-accounts', // We're using document.querySelector() under the hood
        header: {
          title: 'اکانت های api  واتساپ',
        },
        content: 'هر اکانت api به یک اکانت واتساپ متصل می شود با کلیک بر روی هر اکانت میتوانید وضعیت اتصال آن را چک کنید',
      }]
    },
  },

  created() {
    this.getData()
  },

  methods: {
    getData(showLoading = true) {
      if (showLoading) this.loader = true
      this.$http.get('active-services').then(({ data }) => {
        this.services = data
        this.service = this.services[0]
        this.setServiceStatistics()
        this.$http
          .get('accounts', {
            params: {
              me: 1,
            },
          })
          .then(({ data: data2 }) => {
            this.accounts = data2.items
            if (showLoading) this.loader = false
            const showTour = localStorage.getItem('showDashboardTour')
            if ((showTour === undefined || showTour === null) && this.accounts.length > 0) {
              this.$tours.vuexyTour.start()
              localStorage.setItem('showDashboardTour', '1')
            }
            const showEducationalVideoModal = localStorage.getItem('showEducationalVideoModal')
            if (showEducationalVideoModal === undefined || showEducationalVideoModal === null) {
              setTimeout(() => {
                this.$bvModal.show('educational-video-modal')
                localStorage.setItem('showEducationalVideoModal', '1')
              }, 5000)
            }
          })
          .catch(() => {
            if (showLoading) this.loader = false
          })
      })
    },
    setServiceStatistics(){
        this.serviceId = this.service.id
        this.isAllowedAccount = this.service.is_allowed_account && !this.service.is_expired
        this.$http.get(`services/${this.serviceId}/statistic`).then(({ data }) => {
            this.service.number_of_accounts = data.number_of_accounts
            this.service.active_accounts = data.active_accounts
            this.remainingMessages = numberFormat(data.total_messages)
            this.statistics[0].title = `${data.number_of_accounts} / ${data.active_accounts}`
            this.statistics[1].title = data.total_sent_messages
            this.statistics[2].title = data.total_sent_messages_queue
            this.statistics[3].title = data.expire_jat
            if (this.service.is_expired) this.statistics[3].color = 'light-danger'
        })
        this.getDailyMessages();
    },
    getDailyMessages(){
        this.$http.get(`services/${this.serviceId}/daily-messages`).then(({ data }) => {
            this.messageStatistics = {
                series: [
                    {
                        name: this.$t('Message'),
                        data: Object.values(data),
                    },
                ],
            }
        })
    },
    createInvoice(service,type) {
      if (service.is_expired || (service.number_of_accounts <= service.active_accounts && !service.can_buy_extra_account && type === 'extra_account')) {
        this.$router.push({ name: 'invoices-create',params:{
            id: this.serviceId
            }})
      } else {
        this.invoiceType = type
        let modalId = 'create-invoice-modal'
        if (type === 'extra_account' && this.isAllowedAccount) {
          modalId = 'create-account-modal'
        }
        setTimeout(() => {
          this.$bvModal.show(modalId)
        }, 500)
      }
    },
    deleteAccount(item) {
      this.showConfirmWithCheckboxDialog({title:"Are you sure?" , text: "You won't be able to revert this!" ,inputPlaceholder : "I want to reduce the number of additional accounts"}).then((decrementAccounts) => {
        this.$http.delete(`accounts/${item.id}`,{
          params:{
            decrementAccounts,
          }
        }).then(() => {
          this.showSuccessNotification(this.$t('The deletion was successful'))
          this.getData(false)
        }).catch(() => {

        })
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/tour.scss';
</style>
